import React, { ChangeEvent } from 'react';
import { withContent } from '../../../../hoc/withContext';

import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { IContent } from '../../../../types';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  }
}));

interface ISelectFormElementProps {
  context?: IContent;
  label: string;
  values: string[];
  defaultSelected?: string;
  selectValue: (value: string) => void;
  required?: boolean;
  error?: boolean;
}

const SelectFormElement = ({ defaultSelected, error, label, values, required, selectValue }: ISelectFormElementProps) => {
  const styles = useStyles();

  const [selectedValue, setSelectedValue] = React.useState(defaultSelected || "");

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value as string);
    selectValue(event.target.value as string);
  }

  const listItems = values.map((value: string, index: number) => <MenuItem value={value} key={`${encodeURI(label)}_select_${index}`}>{value}</MenuItem>);

  const isUPC = process.env.REACT_APP_ENV === "upc";
  const theme = createMuiTheme({
    palette: {
      type: isUPC ? 'dark' : 'light',
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <FormControl
        variant="outlined"
        className={styles.formControl}
        required={required}
        error={error}
      >
        <InputLabel id={`label-${encodeURI(label)}`}>
          {label.charAt(0).toUpperCase() + label.slice(1)}
        </InputLabel>
        <Select
          labelId={`label-${encodeURI(label)}`}
          id={`select-${encodeURI(label)}`}
          value={selectedValue}
          onChange={(event) => handleChange(event as ChangeEvent<HTMLInputElement>)}
          label={label.charAt(0).toUpperCase() + label.slice(1)}
        >
          {listItems}
        </Select>
      </FormControl>
    </ThemeProvider>
  );
};

export default withContent(SelectFormElement);
